<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="ded"><b>For my junglee muses:</b></p>
<p class="ded1">Ma and Dad</p>
<p class="ded1">Priya</p>
<p class="ded1">David</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?b8fee120